import { render, staticRenderFns } from "./ActivitiesReport.vue?vue&type=template&id=8c21d88a&scoped=true&"
import script from "./ActivitiesReport.vue?vue&type=script&lang=js&"
export * from "./ActivitiesReport.vue?vue&type=script&lang=js&"
import style0 from "./ActivitiesReport.vue?vue&type=style&index=0&id=8c21d88a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c21d88a",
  null
  
)

export default component.exports